import React, { useState } from "react";
import {
  Modal,
  Radio,
  Divider,
  Tag,
  Checkbox,
  Input,
  Button,
  Collapse
} from "antd";
import {
  PlusOutlined,
  MinusOutlined,
  DownOutlined,
  CloseOutlined
} from "@ant-design/icons";
import "./DishModal.scss";
import { useNavigate } from "react-router-dom";

const DishModal = ({ open, onClose }:any) => {
  const [spicyLevel, setSpicyLevel] = useState("Hot");
  const [chooseType, setChooseType] = useState("Boneless");
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [ingredients, setIngredients] = useState<any>([]);
  const [count, setCount] = useState(1);
  const navigate = useNavigate();

  const checkboxList:{name:string,price:number}[] = [
    { name: "Nan", price: 20 },
    { name: "Rotti", price: 2 },
    { name: "Garlic", price: 5 },
    { name: "Rice", price: 10 }
  ];

  const ingredientList = ["Cream", "Chicken", "Beef", "Mutton"];

  const addToCart=()=>{
    navigate(`/checkout`)
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={730}
      className="dish-modal"
    >
      {/* Dish Name */}
      <div className="dish-name">Chicken Curry</div>

      {/* Dish Desc */}
      <div className="dish-desc">
        Delicious spicy chicken curry with authentic Indian spices.
      </div>

      {/* Dish Image */}
      <img
        src="/Home/fastestBg.svg"
        alt="Dish"
        className="dish-image"
      />

      {/* Spicy Level */}
      <div className="section-header">
        <span className="left">Spicy Level</span>
        <span className="right optional">Optional</span>
      </div>
      <Radio.Group
        onChange={(e) => setSpicyLevel(e.target.value)}
        value={spicyLevel}
        className="radio-group"
      >
        <Radio value="Hot">Hot</Radio>
        <Radio value="Medium">Medium</Radio>
        <Radio value="Mild">Mild</Radio>
      </Radio.Group>

      <Divider />

      {/* Choose Type */}
      <div className="section-header">
        <span className="left">Choose Type</span>
        <span className="right required">*Required</span>
      </div>
      <div className="tags-container">
        {["Boneless", "With Bone"].map((type) => (
          <Tag
            key={type}
            className={`custom-tag ${
              chooseType === type ? "selected" : ""
            }`}
            onClick={() => setChooseType(type)}
          >
           {type} <span style={{marginLeft:"10px"}}> {chooseType === type ? <CloseOutlined /> : "+"}  </span>
          </Tag>
        ))}
      </div>

      <Divider />

      {/* Add-ons */}
      <div className="section-header">
        <span className="left">Add-ons</span>
        <span className="right optional">Optional</span>
      </div>
      <div className="checkbox-list">
        {checkboxList.map((item) => (
          <div className="checkbox-item" key={item.name}>
            <Checkbox
              checked={checkedItems.includes(item.name)}
              onChange={(e) => {
                if (e.target.checked) {
                  setCheckedItems([...checkedItems, item.name]);
                } else {
                  setCheckedItems(
                    checkedItems.filter((i:any) => i !== item.name)
                  );
                }
              }}
            >
              {item.name} - ${item.price}
            </Checkbox>
          </div>
        ))}
      </div>

      <Divider />

      {/* Special Instructions */}
      <div className="section-header">
        <span className="left">Any Special Instruction</span>
      </div>
      <Input.TextArea
        rows={4}
        placeholder="Add any special instructions if required here"
        className="special-textarea"
      />

      <Divider />

      {/* Ingredients Expandable */}
      <Collapse
        expandIconPosition="end"
        expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
        className="custom-collapse"
      >
        <Collapse.Panel
          header={
            <div className="section-header">
              <span className="left">Ingredients</span>
            </div>
          }
          key="1"
        >
          {ingredientList.map((ing:any) => (
            <div className="checkbox-item" key={ing}>
              <Checkbox
                checked={ingredients.includes(ing)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setIngredients([...ingredients, ing]);
                  } else {
                    setIngredients(ingredients.filter((i:any) => i !== ing));
                  }
                }}
              >
                {ing}
              </Checkbox>
            </div>
          ))}
        </Collapse.Panel>
      </Collapse>

      <Divider />

      {/* Footer Buttons */}
      <div className="footer-buttons">
        <div className="counter">
          <Button
            className="counter-btn"
            onClick={() => setCount(Math.max(1, count - 1))}
          >
            <MinusOutlined />
          </Button>
          <span className="count">{count}</span>
          <Button className="counter-btn" onClick={() => setCount(count + 1)}>
            <PlusOutlined />
          </Button>
        </div>
        <Button className="add-to-cart-btn" onClick={()=>addToCart()}>
          Add to cart - ${count * 23.0}
        </Button>
      </div>
    </Modal>
  );
};

export default DishModal;
